import React, { useState, useEffect } from 'react'
import { Redirect } from 'react-router-dom'
import { Full as Loading } from 'components/Loading'

const DuplicatePage = ({ history, match: { params: { id } } }) => {
  const [state, setState] = useState(null)

  useEffect(() => {
    fetch(`/rest/v2/order/${id}/fetch`, { credentials: 'same-origin' })
      .then((response) => response.json())
      .then(({ data, meta }) => setState({
        template: {
          ...data,
          attributes: [
            ...data.attributes.map((attr) => ({
              ...attr,
              value: Array.isArray(attr.value) ? null : attr.value,
              disabled: false,
            }))
          ]
        },
      }))
  }, [])


  if (!state) {
    return (
      <Loading />
    )
  }

  const { template, attributes } = state

  return (
    <Redirect
      to={{
        pathname: `/orders/new/${template.meta.hashId}`,
        state: template,
      }}
    />
  )
}

export default DuplicatePage
